import React from 'react';
import PropTypes from 'prop-types';

import ClearIcon from '@material-ui/icons/Clear';

import * as math from '_core/utils/math';


export const DefaultValue = React.memo((props) => {
  const {
    column,
    data
  } = props;
  
  
  const value = math.getField(data, column.nameSplit[0]);
  
  return value === undefined ? '-' : value;
});

export const DefaultFilter = React.memo((props) => null);

export const DefaultTags = React.memo((props) => {
  const {
    classes,
    
    filterApply,
    value
  } = props;
  
  
  return (
    <div className={classes.statusChip}>
      {String(value)}
      
      <a href="" onClick={(event) => { event.preventDefault(); filterApply(null); }}><ClearIcon /></a>
    </div>
  );
});

export const getDefaultApiParam = (column, value) => {
  return String(value);
};

export const getDefaultExportValue = async (props, column, data) => {
  const value = math.getField(data, column.nameSplit[0]);
  
  return value === undefined ? '-' : value;
};
